import React from 'react';
import {InputGroup,FormControl} from 'react-bootstrap'

const Contact = () =>{
    return(
        <>
        <div className="container contactMeHeaderSection d-flex justify-content-center align-items-center">
            <div className="row d-flex flex-column justify-content-center align-items-center">
                <i className="fa fa-envelope fa-2x mb-2"></i>
                <span>CONTACT ME</span>
            </div>
        </div>
        <div className="container contactContentDivMain py-5">
            <div className="row ">
                <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                    <span className="text-center my-2">So If you think I'm the right person for you ?</span>
                    <span className="my-2">Send me you'r message !</span>
                    <a className="my-2 emailText" style={{textDecoration:'none'}} href="mailto:subinadhikari61@gmail.com"><span>subinadhikari61@gmail.com</span></a>
                    <span className="text-center my-2">Or DM me on any of my social media handle</span>
                    <div className="my-2">
                        <a href="https://www.github.com/SubinAdhikari" target="_blank"><i className="fa fa-github fa-2x ml-3"></i></a>
                        <a href="https://www.facebook.com/subin.adhikari.566/" target="_blank"><i className="fa fa-facebook-f fa-2x ml-3"></i></a>
                        <a href="https://www.instagram.com/subinadhikari/" target="_blank"><i className="fa fa-instagram fa-2x ml-3"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div className="spaceInBottom"></div>

        </>
    )
}
export default Contact;